import { useState } from 'react';

import { AddressFieldsContainer } from './AddressFieldsContainer';
import { AddressFormSeparateContainer } from './AddressFormSeparateContainer';

export function AddressFormSeparateFieldsSwitch(
  props: Record<string, unknown>,
) {
  const [separateFields, setSeparateFields] = useState(false);

  const toggleSeparateFields = () => setSeparateFields((s) => !s);

  return separateFields ? (
    <AddressFormSeparateContainer
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      toggleSeparateFields={toggleSeparateFields}
    />
  ) : (
    <AddressFieldsContainer
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      toggleSeparateFields={toggleSeparateFields}
    />
  );
}
